export default __webpack_public_path__ + "static/media/backArrow.98080eae.svg";